import { render } from "./Columns.vue?vue&type=template&id=388855a3&scoped=true&ts=true"
import script from "./Columns.vue?vue&type=script&lang=ts"
export * from "./Columns.vue?vue&type=script&lang=ts"

import "./Columns.vue?vue&type=style&index=0&id=388855a3&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388855a3"]])

export default __exports__